"use client";
import { getCookie } from "@/commonJS/clientStorageActions";
import Image from "next/image";
import Link from "next/link";
import { redirect } from "next/navigation";
import { useEffect, useState } from "react";

const SUPPORTED_LANGS = ["en", "hi", "gu"]; // our supported langs

export default function NotFound() {
  const [isMobile,setIsMobile] = useState<boolean>();
  const rawLang = getCookie("lang");
  const lang = SUPPORTED_LANGS.includes(rawLang ?? "") ? rawLang : "en";

  // if (typeof window !== "undefined") {
  //   const currentUrl = window.location.pathname;
  //   const slug = currentUrl.split("/").pop();
  //   // Redirect to the desired URL using the last part of the current URL
  //   redirect(`/${lang}/search/all?search=${slug}`);
  // }

  useEffect(()=>{
    console.log("window",window,isMobile);
    setIsMobile(typeof window !== 'undefined' ? window.innerWidth < 768 : false);
  },[])

  const Gear = ({
    size,
    color,
    duration,
    reverse = false,
  }: {
    size: number;
    color: string;
    duration: number;
    reverse?: boolean;
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        animation: `nf-spin ${duration}s linear infinite${reverse ? " reverse" : ""}`,
        display: "block",
      }}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill={color}
        d="M54.6 4.6l1.5 8.9c2.9.7 5.7 1.9 8.2 3.4l7.4-5.1 6.4 6.4-5.1 7.4c1.5 2.5 2.7 5.3 3.4 8.2l8.9 1.5v9.1l-8.9 1.5c-.7 2.9-1.9 5.7-3.4 8.2l5.1 7.4-6.4 6.4-7.4-5.1c-2.5 1.5-5.3 2.7-8.2 3.4l-1.5 8.9h-9.1l-1.5-8.9c-2.9-.7-5.7-1.9-8.2-3.4l-7.4 5.1-6.4-6.4 5.1-7.4c-1.5-2.5-2.7-5.3-3.4-8.2l-8.9-1.5v-9.1l8.9-1.5c.7-2.9 1.9-5.7 3.4-8.2l-5.1-7.4 6.4-6.4 7.4 5.1c2.5-1.5 5.3-2.7 8.2-3.4l1.5-8.9h9.1zM50 33a17 17 0 100 34 17 17 0 000-34z"
      />
    </svg>
  );

  return (<html lang="en">
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Not Found</title>
     <style>
        {`*{margin:0;padding:0;scroll-behavior:smooth}@font-face{font-family:'Gotham';src:url('https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/fonts/Gotham/Gotham-Book_may_2025.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:'Gotham';src:url('https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/fonts/Gotham/Gotham-Medium_may_2025.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap}@font-face{font-family:'Gotham';src:url('https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/fonts/Gotham/Gotham-Bold_may_2025.woff2') format('woff2');font-weight:700;font-style:normal;font-display:swap}ul{list-style:none}input:focus-visible{outline:none}textarea:focus-visible{outline:none}button:focus-visible{outline:none}input:disabled{color:#98A2B3}input:disabled::placeholder{color:#98A2B3}details{&[open]{img[data-key="up-arrow"]{transform:rotateZ(180deg);animation:rotate 200ms ease;transform-origin:center}}summary{&::marker{content:""}}}@keyframes rotate{0%{transform:rotateZ(0)}50%{transform:rotateZ(90deg)}100%{transform:rotateZ(180deg)}}.mobile-number-input{&::placeholder{color:#667085}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:textfield;appearance:none;margin:0}}.modal-overlay{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgb(0 0 0 / .5);display:flex;align-items:center;justify-content:center;z-index:5000}.modal-box{box-sizing:border-box;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:5000;height:fit-content;overflow:auto;max-height:calc(100vh - 10%)}.modal-header{display:flex;justify-content:start;align-items:start;width:auto;.close_button{justify-self:flex-end;margin-left:auto}}.filled-primary-btn{color:#fff;background-color:#1957A4;&:hover{background-color:#144887!important}&:active{background-color:#10396C!important}&:disabled{cursor:auto!important;background-color:#A8C9F2!important}}.wired-primary-btn{color:#1957A4;border:1px solid #1957A4;background-color:transparent!important;&:hover{color:#174885;border:1px solid #174885;background-color:#D3E4F7!important}&:active{color:#12396A;border:1px solid #12396A;background-color:#A8C9F0!important}&:disabled{color:#A8C9F2;border:1px solid #A8C9F2;background-color:transparent!important}}.filled-green-btn{color:#fff;background-color:#56B199;&:hover{background-color:#479A84!important}&:disabled{background-color:#8BCAB9!important}}.big-dot{&::marker{font-size:16px;margin-right:-5px}}.table{border-collapse:collapse;th,td{border:1px solid #D0D5DD}}.fade-strach-up{animation:fade-up-drawer;animation-duration:0.5s;transform:none;top:auto}.red_asterisk{&::after{content:"*";color:#D92D20}}@keyframes fade-up-drawer{from{transform:translateY(100%)}to{transform:translateY(0%)}}.overlay{position:fixed;top:0;left:0;height:100vh;width:100vw;background-color:rgb(0 0 0 / .5);z-index:4999;overflow:hidden}.horizontal_bottom_bar{width:100%;border:1px solid #D0D5DD;position:absolute;bottom:18px}.bar-graph{position:relative}.bar-parent-container{display:flex;align-items:flex-end}.bar{display:flex;flex-direction:column;align-items:center;.bar-progress{border-radius:8px 8px 0 0;width:89px}}.bar-container{flex-grow:1;label{display:flex;justify-content:center}}.bar-graph-main-label{color:#000;font-size:10px;font-weight:400;line-height:15px;text-align:center;padding-top:5px}.dropdown-modal{position:absolute;top:100%;left:0;z-index:5;width:100%}.otp-input:focus{border:1px solid #287ADF!important}.mobile-drawer{background:#fff;position:fixed;top:0;height:calc(0px + 100vh);left:0;min-width:300px;animation-name:mobiledrawer;animation-duration:0.5s;transform:none;z-index:5001;max-height:100%}@keyframes mobiledrawer{from{left:-300px}to{transition:all 0.4s ease;left:0}}.medkart-assured-drawer{z-index:5000;min-width:300px;max-width:450px;animation-name:medkartAssuredDrawer;animation-duration:0.5s;transform:none;left:auto;max-height:100%}@keyframes medkartAssuredDrawer{from{right:-100%}to{transition:all 0.4s ease;right:0}}.medkart-assured-drawer-web{z-index:2000;min-width:450px;max-width:450px;animation-name:medkartAssuredDrawerWeb;animation-duration:0.5s}@keyframes medkartAssuredDrawerWeb{from{right:-100%}to{transition:all 0.4s ease;right:0}}.border-none{border:none!important}.toaster{display:flex;justify-content:space-between;align-items:center;gap:8px;padding:10px 11px;border-radius:32px;position:fixed;bottom:50px;left:50%;transform:translateX(-50%);z-index:9999;animation:slide-up 300ms ease;&.toaster-mobile{width:60%;max-width:80%;p{width:fit-content}}}@keyframes slide-up{0%{transform:translate(-50%,350px);opacity:0}100%{transform:translate(-50%,0);opacity:1}}.toaster-success{background-color:#17B26A}.toaster-warn{background-color:#F79009}.toaster-error{background-color:#F04438}.gradient-primary-text{background:linear-gradient(275.9deg,#56B199 0%,#144887 56.15%);-webkit-background-clip:text;-webkit-text-fill-color:#fff0;display:inline-block}.primary-checkbox{appearance:none;border:1px solid #D0D5DD;border-radius:4px;&:checked{background-color:#1957a4;border-color:#1957a4;background-image:url(https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/icons/check.svg);background-repeat:no-repeat;background-position:center;background-size:14px}}.primary-radio{appearance:none;border:2px solid #667085;border-radius:50%;&:checked{background-color:#1957a4;border-color:#1957a4;background-image:url(https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/icons/check.svg);background-repeat:no-repeat;background-position:center;background-size:14px}}.blue_light{background-color:#D3E4F8!important}.d-none{display:none!important}.d-hidden{visibility:hidden!important}.d-block{display:block!important}.navbar-transition{transform:translateY(0)!important;transition:all 200ms ease}.secondary-navbar-init{position:fixed;transform:translateY(0px)}.list_item_prefix{&:before{content:"•"}}.accordion-open{img{transform:rotateZ(180deg)}}.accordion-group:has(details[open]) summary img{transform:rotateZ(180deg)}details[open] summary .accordion-toggle-image{transform:rotate(180deg)}summary{-webkit-tap-highlight-color:#fff0}#fc_frame,#fc_frame.fc-widget-small{z-index:4000!important} details[open] summary .accordion-toggle-image-transform{transform:rotate(0deg) !important}.carousel-hover-button{background-color:#d3e4f880!important;transition:background-color .3s}.carousel-hover-button:hover{background-color:#d3e4f8!important}.dropdown-option{background-color:transparent;transition:background-color .2s ease-in-out;cursor:pointer}.dropdown-option:hover{background-color:#edf4fc}
        .mobile-navbar{display:none !important}.mobile-footer{display:none !important}@media screen and (max-width: 768px){.webNavbar{display:none}.web_seconday_navbar{display:none}.web-footer{display:none}.mobile-navbar{display:flex !important}.mobile-footer{display:block !important}}`}
      </style>
      <link
        rel="preload"
        href="https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/fonts/Gotham/Gotham-Book_may_2025.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        href="https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/fonts/Gotham/Gotham-Medium_may_2025.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        href="https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/fonts/Gotham/Gotham-Bold_may_2025.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
    </head>
    <body style={{
      margin: 0,
      fontFamily: "Gotham, system-ui, sans-serif",
      background: "#f7f7f8",
      color: "#1a1a1a",
    }}>
      <div style={{ width: "100%", height: "100vh" }}>
        <MobileNavbar404 />
        <Navbar404 />
        <SecondaryNavbar />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // justifyContent: "center",
            // width: "calc(100vw - 15px)",
            // height: "calc(100vh - 110px)",
            overflow: "hidden",
            background: "#fff",
            textAlign: "center",
            padding: "24px",
            boxSizing: "border-box",
            // margin: "-8px",
            gap: "20px",
            fontFamily: "Gotham, system-ui, sans-serif",
          }}
        >
          {/* Gear spin keyframes (scoped inline so the page needs no external CSS) */}
          <style>{`@keyframes nf-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
          {/* Centered logo */}
          {/* <Image
            src="https://mk-p.s3.ap-south-1.amazonaws.com/website/new_ecom_asset/logo.svg"
            alt="Medkart Logo"
            width={160}
            height={40}
            priority
          /> */}

          {/* Large "404" with gears behind the text */}
          <div
            style={{
              position: "relative",
              width: "min(90vw, 520px)",
              height: "min(25vh, 280px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "5vh",
            }}
          >
            {/* Gears layer (behind the text) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                zIndex: 0,
                opacity: 0.18,
              }}
              aria-hidden="true"
            >
              <Gear size={170} color="#1957A4" duration={9} />
              <Gear size={120} color="#56B199" duration={7} reverse />
            </div>

            {/* 404 text on top */}
            <span
              style={{
                position: "relative",
                zIndex: 1,
                fontSize: "clamp(96px, 22vw, 110px)",
                fontWeight: 700,
                lineHeight: 1,
                color: "#1957A4",
                letterSpacing: "4px",
              }}
            >
              404
            </span>
          </div>

          {/* Single-line generic text */}
          <p
            style={{
              color: "#667085",
              fontSize: "16px",
              lineHeight: "24px",
              margin: 0,
            }}
          >
            Oops! The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </p>

          {/* Back to home button -> "/" */}
          <Link
            href="/"
            aria-label="Back to home"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: 500,
              textDecoration: "none",
              cursor: "pointer",
              background:
                "linear-gradient(275.9deg, #479A84 0%, #3A7986 20.4%, #2B627D 38.97%, #10396C 67.79%)",
              color: "white",
            }}
          >
            Back to home
          </Link>
        </div>
        <MobileFooter />
        <Footer404 />
        
      </div>
    </body>
  </html>
  )
}

export const Navbar404 = () => {
  const NAV_LINKS = [
  { label: "Home", href: "/", active: true },
  { label: "Medicines", href: "/order-medicine" },
  { label: "Store Locator", href: "/store-locator" },
  { label: "Compare Medicines", href: "/compare-medicines" },
];
  return (
     <div
      style={{
        position: "sticky",
        top: 0,
        background: "rgb(255, 255, 255)",
        zIndex: 2000,
        minHeight: 68,
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 4px 8px 0px",
      }}
      className="webNavbar"
    >
      <div
        id="navbar"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 16px",
          maxWidth: 1366,
          margin: "auto",
        }}
      >
        {/* Logo + pincode */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href="/"
            aria-label="Medkart Logo"
            style={{ height: 44, width: 171.45, cursor: "pointer" }}
          >
            <img
              alt="Medkart Logo"
              width={171.45}
              height={44}
              loading="lazy"
              decoding="async"
              src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/logo1.webp`}
              style={{
                color: "transparent",
                position: "static",
                borderRadius: 0,
                height: 44,
                width: 171.45,
                cursor: "pointer",
              }}
            />
          </a>
 
          <div
            className="pincode-dropdown-button-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
              padding: "0 16px",
              width: "130px"
            }}
          >
           
          </div>
        </div>

        <div
          style={{
            position: "relative",
            width: "fit-content",
            border: "1px solid rgb(40, 122, 223)",
            backgroundColor: "rgb(242, 244, 247)",
            borderRadius: 50,
            minWidth: 600,
          }}
        >
          <img
            alt="Search icon"
            width={24}
            height={24}
            loading="lazy"
            decoding="async"
            src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/search_icon.svg`}
            style={{
              color: "transparent",
              position: "absolute",
              borderRadius: 0,
              width: 24,
              height: 24,
              top: 8,
              left: 10,
              zIndex: 500,
            }}
          />
          <a
            href="/search"
            aria-label="Medkart Image"
            style={{
              position: "relative",
              padding: "8px 10px 8px 42px",
              fontSize: 14,
              fontWeight: 400,
              lineHeight: "24px",
              width: "91%",
              display: "inline-block",
              color: "rgb(102, 112, 133)",
              height: 24,
              textDecoration: "none",
              borderRadius: 50,
            }}
          >
            Search Medicines or wellness
          </a>
        </div>
 
        {/* Nav links */}
        {/* <div className="d-block" style={{ margin: "auto" }}>
          <ul
            style={{
              display: "flex",
              gap: 8,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "20px",
              justifyContent: "center",
              listStyle: "none",
            }}
          >
            {NAV_LINKS.map((link) => (
              <li
                key={link.href}
                className={link.active ? "active_item_style_web" : ""}
                style={{ padding: "4px 8px" }}
              >
                <a
                  className="border-bottom-white"
                  href={link.href}
                  style={{
                    padding: "6px 8px",
                    color: "rgb(12, 17, 29)",
                    textDecoration: "none",
                    borderBottom: "1px solid transparent",
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div> */}
 
        {/* Language / Cart / Sign in */}
        <div
          className="flex items-center"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: 23,
            position: "relative",
            minWidth: 141,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: 37,
            }}
          >
            <img
              alt="Language selection icon"
              width={24}
              height={24}
              loading="lazy"
              decoding="async"
              src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/language_icon.svg`}
              style={{
                color: "transparent",
                position: "static",
                borderRadius: 0,
                width: 24,
                height: 24,
                display: "flex",
                cursor: "pointer",
              }}
            />
            <p
              style={{
                fontSize: 10,
                lineHeight: "15px",
                fontWeight: 500,
                color: "rgb(12, 17, 29)",
                cursor: "pointer",
                margin: 0,
              }}
            >
              English
            </p>
          </div>
 
          <a
            href="/cart"
            aria-label="Cart icon"
            style={{ textDecoration: "none", minWidth: 24 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
              }}
            >
              <img
                alt="Cart icon"
                width={24}
                height={24}
                loading="lazy"
                decoding="async"
                src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/cart1.webp`}
                style={{
                  color: "transparent",
                  position: "static",
                  borderRadius: 0,
                  width: 24,
                  height: 24,
                  display: "flex",
                  cursor: "pointer",
                }}
              />
              <p
                style={{
                  fontSize: 10,
                  lineHeight: "15px",
                  fontWeight: 500,
                  color: "rgb(12, 17, 29)",
                  cursor: "pointer",
                  margin: 0,
                }}
              >
                Cart
              </p>
            </div>
          </a>
 
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: 35,
            }}
          >
            <img
              alt="signin_icon"
              width={24}
              height={24}
              loading="lazy"
              decoding="async"
              src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/signi_in_icon.svg`}
              style={{
                color: "transparent",
                position: "static",
                borderRadius: 0,
                width: 24,
                height: 24,
                display: "flex",
                cursor: "pointer",
              }}
            />
            <p
              style={{
                fontSize: 10,
                lineHeight: "15px",
                fontWeight: 500,
                color: "rgb(12, 17, 29)",
                cursor: "pointer",
                margin: 0,
              }}
            >
              Sign in
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}


export const SecondaryNavbar = ({ activePath = '/', isVisible = false }) => {
  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'Medicines', href: '/order-medicine' },
    { label: 'Store Locator', href: '/store-locator' },
    { label: 'Compare Medicines', href: '/compare-medicines' },
  ];
  
  const navbarStyle: React.CSSProperties = {
    background: 'linear-gradient(275.9deg, #479A84 0%, #3A7986 20.4%, #2B627D 38.97%, #10396C 67.79%)',
    position: 'sticky',
    top: 68,
    zIndex: 1999,
    width: '100%',
  };
  
  const containerStyle: React.CSSProperties = {
    padding: '10px 0',
    maxWidth: 1140,
    margin: 'auto',
  };
  
  const listStyle: React.CSSProperties = {
    display: 'flex',
    gap: 8,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    justifyContent: 'center',
    listStyle: 'none',
    margin: 0,
    padding: 0,
  };
  
  const linkStyle:any = {
    padding: '6px 8px',
    color: '#fff',
    textDecoration: 'none',
    borderBottom: '1px solid transparent',
  };
  return (
    <div
      // className={`secondary-navbar-init ${isVisible ? '' : 'd-hidden'}`}
      style={navbarStyle}
      className="web_seconday_navbar"
    >
      <div style={containerStyle}>
        <ul style={listStyle}>
          {navItems.map((item) => {
            // const isActive = item.href === activePath;
            return (
              <li key={item.href} 
                  // 
                  className="border-bottom-white"
              >
                <a
                  href={item.href}
                  style={{
                    padding: "6px 8px",
                    color: "#fff",
                    textDecoration: "none",
                    borderBottom: "1px solid transparent"
                  }}>

                  {item.label}
                </a>
                
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};


const stats = [
  { value: '10 Lakh+', label: 'Happy customers' },
  { value: '35000+', label: 'Pin-codes Covered' },
  { value: '75 Lakh+', label: 'Orders Delivered' },
];

const footerColumns = [
  {
    title: 'About Medkart Pharmacy',
    links: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Contact Us', href: '/contact-us' },
      { label: 'Franchise', href: '/franchise' },
      { label: 'Blog', href: 'https://www.medkart.in/blog' },
      { label: 'Download App', href: '/download-app' },
    ],
  },
  {
    title: 'Our Services',
    links: [
      { label: 'Order Medicines', href: '/order-medicine' },
      { label: 'Generic Medicines', href: '/know-generic-medicine' },
      { label: 'Compare Medicines', href: '/compare-medicines' },
      { label: 'Locate Nearest Store', href: '/store-locator' },
      { label: 'Stores Page', href: 'https://stores.medkart.in/', external: true },
    ],
  },
  {
    title: 'Browse by',
    links: [
      { label: 'Browse All Medicines', href: '/browse-all-medicines?alphabet=a&page=1' },
      { label: 'Browse All Molecules', href: '/browse-all-molecules?alphabet=a&page=1' },
      { label: 'Medical Store Near You', href: '/medical-store' },
    ],
  },
  {
    title: 'Policies',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of services', href: '/terms-and-conditions' },
      { label: 'Return & Refund Policy', href: '/return-policy' },
    ],
  },
];

const socialLinks = [
  { label: 'Medkart LinkedIn', href: 'https://in.linkedin.com/company/medkart-pharmacy', icon: 'linkedin1.webp' },
  { label: 'Medkart Facebook', href: 'https://www.facebook.com/medkartpharmacy/', icon: 'facebook1.webp' },
  { label: 'Medkart Instagram', href: 'https://www.instagram.com/medkartpharmacy/', icon: 'instagram1.webp' },
  { label: 'Medkart YouTube', href: 'https://www.youtube.com/c/MedkartPharmacy', icon: 'youtube1.webp' },
];

const appLinks = [
  {
    label: 'Download from Google play',
    href: 'https://play.google.com/store/apps/details?id=in.medkart',
    icon: 'playstore1.webp',
    width: 135,
    height: 40,
  },
  {
    label: 'Download from App Store',
    href: 'https://apps.apple.com/in/app/medkart-pharmacy-generic-meds/id6443615062',
    icon: 'appstore1.webp',
    width: 135,
    height: 40,
  },
];

const ASSET_BASE = 'https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset';

// const linkStyle = {
//   color: '#0C111D',
//   fontSize: 12,
//   fontWeight: 400,
//   lineHeight: '18px',
//   textDecoration: 'none',
// };

const columnTitleStyle = {
  fontSize: 14,
  fontWeight: 500,
  color: '#101828',
};

export const Footer404 = () => {
  return (
    <div className="web-footer">
      {/* Trust banner */}
      <div style={{ padding: '16px 0', backgroundColor: '#D3E4F8', margin: '0 auto' }}>
        <div style={{ maxWidth: 1140, margin: 'auto', borderBottom: '1px solid #D0D5DD' }}>
          <h2 style={{ fontSize: 18, fontWeight: 500, lineHeight: '28px', color: '#1957A4', textAlign: 'center' }}>
            India's most trusted generic medicine pharmacy.
          </h2>
          <div style={{ display: 'flex', padding: '24px 0' }}>
            {stats.map((stat) => (
              <div
                key={stat.label}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '33.33%' }}
              >
                <p style={{ fontSize: 24, fontWeight: 500, lineHeight: '32px', color: '#1957A4' }}>{stat.value}</p>
                <p style={{ fontSize: 16, fontWeight: 400, lineHeight: '24px', color: '#1957A4' }}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 24 }}>
          <img
            alt="WHO GMP Logo"
            width={100}
            height={100}
            loading="lazy"
            decoding="async"
            style={{ color: 'transparent', width: 100, height: 100 }}
            src={`${ASSET_BASE}/whogmp1.webp`}
          />
          <p style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px', color: '#1957A4', paddingTop: 10 }}>
            Authentic Products
          </p>
          <p style={{ fontSize: 12, fontWeight: 400, lineHeight: '18px', color: '#1957A4' }}>
            All WHO-GMP Certified Medicines
          </p>
        </div>
      </div>

      {/* Link columns */}
      <div style={{ maxWidth: 1140, margin: 'auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', padding: '28px 0px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {footerColumns.map((column) => (
              <div key={column.title} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <h3 style={columnTitleStyle}>{column.title}</h3>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: 12, listStyle: 'none', margin: 0, padding: 0 }}>
                  {column.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        style={linkStyle}
                        {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Social + app download */}
      <div style={{ maxWidth: 1140, margin: 'auto' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '32px 0',
            borderTop: '1px solid #EAECF0',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, width: '50%' }}>
            <h4 style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>Follow Us On</h4>
            <div style={{ display: 'flex', gap: 26, height: 'fit-content' }}>
              {socialLinks.map((social) => (
                <a
                  key={social.href}
                  target="_blank"
                  rel="noopener"
                  aria-label={social.label}
                  href={social.href}
                >
                  <img
                    alt={social.label}
                    width={32}
                    height={32}
                    loading="lazy"
                    decoding="async"
                    style={{ color: 'transparent' }}
                    src={`${ASSET_BASE}/${social.icon}`}
                  />
                </a>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, width: '50%' }}>
            <h4 style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>Download the app for free</h4>
            <div style={{ display: 'flex', gap: 12 }}>
              {appLinks.map((app) => (
                <a key={app.href} target="_blank" rel="noopener" aria-label={app.label} href={app.href}>
                  <img
                    alt={app.label}
                    width={app.width}
                    height={app.height}
                    loading="lazy"
                    decoding="async"
                    style={{ color: 'transparent' }}
                    src={`${ASSET_BASE}/${app.icon}`}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div style={{ maxWidth: 1140, margin: 'auto', borderTop: '1px solid #EAECF0' }}>
        <p style={{ textAlign: 'center', color: '#667085', fontSize: 12, fontWeight: 400, padding: '12px 0', lineHeight: '20px' }}>
          ©2025 Medkart Pharmacy. All Rights Reserved
        </p>
      </div>
    </div>
  );
};

const navbarStyle : any = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  justifyContent: 'space-between',
  padding: '9px 16px',
  margin: 'auto',
  position: 'sticky',
  top: 0,
  background: '#FFF',
  zIndex: 2000,
  height: 34,
};

const MobileNavbar404 = ({

  showSearchIcon = false,
  cartCount = 0,
}) => {

  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  return (
    <div style={navbarStyle} id="navbar" className="mobile-navbar">
      {/* Logo + hamburger */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* <img
          alt="User"
          width={24}
          height={24}
          loading="lazy"
          decoding="async"
          style={{ color: 'transparent', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer' }}
          src={`${ASSET_BASE}/icons/hamburger.svg`}
          onClick={() =>{ window.location.href = '/';}}
        /> */}
        <a
          id="logo"
          target="_self"
          aria-label="Medkart Logo"
          href="/"
          style={{ height: 34, width: 132, cursor: 'pointer' }}
        >
          <img
            alt="Medkart Logo"
            width={132}
            height={34}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            style={{ color: 'transparent', height: 34, width: 132, cursor: 'pointer' }}
            src={`${ASSET_BASE}/logo1_190_49.webp`}
          />
        </a>
      </div>

      {/* Search bar */}
      <div
        id="navbar_search"
        className={isSideBarOpen ? '' : 'd-none'}
        style={{ flexGrow: 1, overflow: 'hidden' }}
      >
        <div
          style={{
            position: 'relative',
            width: 'auto',
            border: '1px solid #D0D5DD',
            background: '#ffffff',
            borderRadius: 50,
          }}
        >
          <img
            alt="Search icon"
            width={24}
            height={24}
            loading="lazy"
            decoding="async"
            style={{
              color: 'transparent',
              position: 'absolute',
              width: 24,
              height: 24,
              top: 6,
              left: 10,
              zIndex: 500,
            }}
            src={`${ASSET_BASE}/icons/search_icon.svg`}
          />
          <a
            target="_self"
            aria-label="Medkart Image"
            href="/search"
            style={{
              position: 'relative',
              padding: '8px 10px 8px 42px',
              fontSize: 14,
              fontWeight: 400,
              lineHeight: '20px',
              width: '100%',
              color: '#667085',
              textDecoration: 'none',
              borderRadius: 50,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Search from 30000+ products
          </a>
        </div>
      </div>

      {/* Right-side icons */}
      <div
        id="navbar_items"
        style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 16 }}
      >
        <a
          id="search_icon"
          target="_self"
          aria-label="User"
          href="/search"
          className={showSearchIcon ? '' : 'd-none'}
          style={{ display: 'flex', width: 24, height: 24 }}
        >
          <img
            alt="User"
            width={24}
            height={24}
            loading="lazy"
            decoding="async"
            style={{ color: 'transparent', display: 'flex', width: 24, height: 24 }}
            src={`${ASSET_BASE}/icons/search_black.svg`}
          />
        </a>

        <a
          target="_self"
          aria-label="Cart icon"
          href="/cart"
          style={{ marginLeft: 'auto' }}
        >
          <div style={{ position: 'relative' }}>
            <img
              alt="Cart icon"
              width={24}
              height={24}
              loading="lazy"
              decoding="async"
              style={{ color: 'transparent', display: 'flex', width: 24, height: 24 }}
              src={`${ASSET_BASE}/cart1.webp`}
            />
            {cartCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: -6,
                  right: -6,
                  background: '#D92D20',
                  color: '#fff',
                  fontSize: 10,
                  fontWeight: 600,
                  lineHeight: '14px',
                  borderRadius: '50%',
                  minWidth: 16,
                  height: 16,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 2px',
                }}
              >
                {cartCount > 99 ? '99+' : cartCount}
              </span>
            )}
          </div>
        </a>
      </div>
    </div>
  );
};


import React from 'react';


const statsFooter:any[] = [
  { value: '10 Lakh+', label: 'Happy customers' },
  { value: '35000+', label: 'Pin-codes Covered' },
  { value: '75 Lakh+', label: 'Orders Delivered' },
];

const accordionSections = [
  {
    title: 'About Medkart Pharmacy',
    links: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Contact Us', href: '/contact-us' },
      { label: 'Franchise', href: '/franchise' },
      { label: 'Blog', href: 'https://www.medkart.in/blog' },
      { label: 'Download App', href: '/download-app' },
    ],
  },
  {
    title: 'Our Services',
    links: [
      { label: 'Order Medicines', href: '/order-medicine' },
      { label: 'Generic Medicines', href: '/know-generic-medicine' },
      { label: 'Compare Medicines', href: '/compare-medicines' },
      { label: 'Locate Nearest Store', href: '/store-locator' },
      { label: 'Stores Page', href: 'https://stores.medkart.in/', external: true },
    ],
  },
  {
    title: 'Browse by',
    links: [
      { label: 'Browse All Medicines', href: '/browse-all-medicines?alphabet=a&page=1' },
      { label: 'Browse All Molecules', href: '/browse-all-molecules?alphabet=a&page=1' },
      { label: 'Medical Store Near You', href: '/medical-store' },
    ],
  },
  {
    title: 'Policies',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of services', href: '/terms-and-conditions' },
      { label: 'Return & Refund Policy', href: '/return-policy' },
    ],
  },
];

// const socialLinks = [
//   { label: 'Medkart LinkedIn', href: 'https://in.linkedin.com/company/medkart-pharmacy', icon: 'linkedin1.webp' },
//   { label: 'Medkart Facebook', href: 'https://www.facebook.com/medkartpharmacy/', icon: 'facebook1.webp' },
//   { label: 'Medkart Instagram', href: 'https://www.instagram.com/medkartpharmacy/', icon: 'instagram1.webp' },
//   { label: 'Medkart YouTube', href: 'https://www.youtube.com/c/MedkartPharmacy', icon: 'youtube1.webp' },
// ];

// const appLinks = [
//   {
//     label: 'Download from Google play',
//     href: 'https://play.google.com/store/apps/details?id=in.medkart',
//     icon: 'playstore1.webp',
//   },
//   {
//     label: 'Download from App Store',
//     href: 'https://apps.apple.com/in/app/medkart-pharmacy-generic-meds/id6443615062',
//     icon: 'appstore1.webp',
//   },
// ];

const linkStyle = {
  color: '#0C111D',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '18px',
  textDecoration: 'none',
};

const summaryStyle = {
  display: 'flex',
  gap: 8,
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '20px',
  color: '#0C111D',
  padding: '10px 0',
};

const MobileFooter = () => {
  return (
    <div className="mobile-footer">
      {/* Logo + tagline */}
      <div
        style={{
          backgroundColor: '#F2F4F7',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          margin: 'auto',
          padding: 24,
          alignItems: 'center',
        }}
      >
        <a href="/" aria-label="product" style={{ height: 34, width: 132, cursor: 'pointer' }}>
          <img
            alt="Medkart Logo"
            width={132}
            height={34}
            loading="lazy"
            decoding="async"
            style={{ color: 'transparent', height: 34, width: 132, cursor: 'pointer' }}
            src={`${ASSET_BASE}/logo1_190_49.webp`}
          />
        </a>
        <div style={{ display: 'flex', fontStyle: 'italic' }}>
          <p style={{ fontSize: 12, fontWeight: 500, lineHeight: '18px', color: '#1957A4', marginRight: 4 }}>
            Saving
          </p>
          <p style={{ fontSize: 12, fontWeight: 700, lineHeight: '18px', color: '#067647', fontStyle: 'italic' }}>
            Money
          </p>
          <p style={{ fontSize: 12, fontWeight: 500, lineHeight: '18px', color: '#1957A4' }}>, Saving Life</p>
        </div>
      </div>

      {/* Trust banner */}
      <div style={{ margin: '0 auto' }}>
        <div style={{ margin: 'auto', padding: 16, backgroundColor: '#10396C', color: '#FFFFFF' }}>
          <h2 style={{ fontSize: 12, fontWeight: 500, lineHeight: '18px', textAlign: 'left' }}>
            India's most trusted generic medicine pharmacy.
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', padding: '16px 0', gap: 8 }}>
            {statsFooter.map((stat) => (
              <div key={stat.label}>
                <p style={{ fontSize: 20, fontWeight: 500, lineHeight: '30px' }}>{stat.value}</p>
                <p style={{ fontSize: 12, fontWeight: 400, lineHeight: '18px' }}>{stat.label}</p>
              </div>
            ))}
          </div>
          <hr style={{ borderTop: '1px solid #D0D5DD' }} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', paddingTop: 16 }}>
            <img
              alt="WHO GMP Logo"
              width={62}
              height={62}
              loading="lazy"
              decoding="async"
              style={{ color: 'transparent', width: 62, height: 62, gridRow: 'span 2' }}
              src={`${ASSET_BASE}/whogmp1.webp`}
            />
            <p style={{ gridColumn: 'span 4', fontSize: 14, fontWeight: 500, lineHeight: '20px', alignSelf: 'flex-end' }}>
              Authentic Products
            </p>
            <p style={{ gridColumn: 'span 4', fontSize: 12, fontWeight: 400, lineHeight: '18px' }}>
              All WHO-GMP Certified Medicines
            </p>
          </div>
        </div>
      </div>

      {/* Accordions */}
      <div style={{ backgroundColor: '#D3E4F8', padding: 16 }}>
        {accordionSections.map((section, index) => (
          <React.Fragment key={section.title}>
            <details>
              <summary style={summaryStyle}>
                {section.title}
                <img
                  alt="Arrow"
                  width={24}
                  height={24}
                  loading="lazy"
                  decoding="async"
                  className="accordion-toggle-image"
                  style={{ color: 'transparent', display: 'flex', alignItems: 'center' }}
                  src={`${ASSET_BASE}/icons/down-arrow.svg`}
                />
              </summary>
              <div style={{ paddingBottom: 10 }}>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: 12, listStyle: 'none', margin: 0, padding: 0 }}>
                  {section.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        style={linkStyle}
                        {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </details>
            <hr style={{ borderColor: '#9BBEEA' }} />
          </React.Fragment>
        ))}
      </div>

      {/* App download + social */}
      <div style={{ margin: 'auto', backgroundColor: '#D3E4F8' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 16px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h4 style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>Download the app for free</h4>
            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              {appLinks.map((app) => (
                <a key={app.href} target="_blank" rel="noopener" aria-label={app.label} href={app.href}>
                  <img
                    alt={app.label}
                    width={149}
                    height={44}
                    loading="lazy"
                    decoding="async"
                    style={{ color: 'transparent' }}
                    src={`${ASSET_BASE}/${app.icon}`}
                  />
                </a>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 32 }}>
            <h4 style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>Follow Us On</h4>
            <div style={{ display: 'flex', gap: 26, marginTop: 24 }}>
              {socialLinks.map((social) => (
                <a key={social.href} target="_blank" rel="noopener" aria-label={social.label} href={social.href}>
                  <img
                    alt={social.label}
                    width={44}
                    height={44}
                    loading="lazy"
                    decoding="async"
                    style={{ color: 'transparent' }}
                    src={`${ASSET_BASE}/${social.icon}`}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div style={{ margin: 'auto', backgroundColor: '#D3E4F8' }}>
        <p
          style={{
            borderTop: '1px solid #FFFFFF',
            textAlign: 'center',
            color: '#0C111D',
            fontSize: 14,
            fontWeight: 400,
            padding: '14px 16px',
            lineHeight: '20px',
          }}
        >
          ©2025 Medkart Pharmacy. All Rights Reserved
        </p>
      </div>
    </div>
  );
};